import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  initialize() {
    this.showMessage = false;

    // Checks if should display install popup notification
    if (! this.isInStandaloneMode() && ( this.isIOS() || this.isIpadOS())) {
      this.showMessage = true;
    }
  }

  isInStandaloneMode() {
    return ('standalone' in window.navigator) && (window.navigator.standalone);
  }

  isIOS() {
    if (/iPad|iPhone|iPod/.test(navigator.platform)) {
      return true;
    }

    return false;
  }

  isIpadOS() {
    return navigator.maxTouchPoints &&
      navigator.maxTouchPoints > 2 &&
      /MacIntel/.test(navigator.platform);
  }

  close() {
    this.element.classList.add('c-bubble--hidden');
    document.cookie = "hide_add_to_homescreen_bubble=true; path=/;";
  }

  connect() {
    if ( this.showMessage ) {
      this.element.classList.toggle('c-bubble--hidden');

      if ( this.isIOS() ) {
        this.element.classList.toggle('c-bubble--ios');
      }

      if ( this.isIpadOS() ) {
        this.element.classList.toggle('c-bubble--ipados');
      }
    }
  }
}
